// Price Range Dual Slider
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-price-range]').forEach(initPriceRange);

  // Re-init after facets AJAX update
  const observer = new MutationObserver(function () {
    document.querySelectorAll('[data-price-range]').forEach(initPriceRange);
  });
  const container = document.getElementById('ProductGridContainer');
  if (container) observer.observe(container, { childList: true, subtree: true });
  const facetsContainer = document.getElementById('FacetsWrapperDesktop');
  if (facetsContainer) observer.observe(facetsContainer, { childList: true, subtree: true });
});

function initPriceRange(wrapper) {
  if (wrapper.dataset.initialized) return;
  wrapper.dataset.initialized = 'true';

  const minSlider = wrapper.querySelector('[data-price-range-min]');
  const maxSlider = wrapper.querySelector('[data-price-range-max]');
  const progress = wrapper.querySelector('[data-price-progress]');
  if (!minSlider || !maxSlider || !progress) return;

  const parent = wrapper.closest('price-range') || wrapper.parentElement;
  const minField = parent.querySelector('input[id*="GTE"]');
  const maxField = parent.querySelector('input[id*="LTE"]');

  function updateProgress() {
    const max = parseFloat(maxSlider.max) || 100;
    const minVal = parseFloat(minSlider.value) || 0;
    const maxVal = parseFloat(maxSlider.value) || max;
    const leftPct = (minVal / max) * 100;
    const rightPct = (maxVal / max) * 100;
    progress.style.left = leftPct + '%';
    progress.style.width = (rightPct - leftPct) + '%';
  }

  function onMinChange() {
    let minVal = parseFloat(minSlider.value);
    let maxVal = parseFloat(maxSlider.value);
    if (minVal > maxVal) {
      minSlider.value = maxVal;
      minVal = maxVal;
    }
    if (minField) {
      minField.value = minVal > 0 ? minVal + '.00' : '';
      minField.dispatchEvent(new Event('input', { bubbles: true }));
    }
    updateProgress();
  }

  function onMaxChange() {
    let minVal = parseFloat(minSlider.value);
    let maxVal = parseFloat(maxSlider.value);
    if (maxVal < minVal) {
      maxSlider.value = minVal;
      maxVal = minVal;
    }
    if (maxField) {
      const sliderMax = parseFloat(maxSlider.max);
      maxField.value = maxVal < sliderMax ? maxVal + '.00' : '';
      maxField.dispatchEvent(new Event('input', { bubbles: true }));
    }
    updateProgress();
  }

  minSlider.addEventListener('input', onMinChange);
  maxSlider.addEventListener('input', onMaxChange);

  // Sync text fields -> sliders
  if (minField) {
    minField.addEventListener('change', function () {
      const val = parseFloat(this.value.replace(/[^0-9.]/g, '')) || 0;
      minSlider.value = val;
      updateProgress();
    });
  }
  if (maxField) {
    maxField.addEventListener('change', function () {
      const val = parseFloat(this.value.replace(/[^0-9.]/g, '')) || parseFloat(maxSlider.max);
      maxSlider.value = val;
      updateProgress();
    });
  }

  updateProgress();
}
